/* eslint-disable react/no-this-in-sfc */
/* eslint-disable object-shorthand */
import React, { useState, useEffect } from 'react';
import Highcharts from 'highcharts';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import HighchartsReact from 'highcharts-react-official';
import { Box, CircularProgress, Paper, Tab, Tabs } from '@material-ui/core';
import PeriodicityButton from './utils/PeriodicityButton';
import ExportCsvButton from './utils/ExportCsvButton';
import { exportToCsv, exportToExcel } from './utils/csvExport';
import {
  getProcessedQuantities,
  getShippedQuantities,
  getProcessedItemsNaturesQuantities,
  getProcessedShipmentsNaturesQuantities
} from '../dashboardActions';

const ShippedAndReturnChart = ({
  processedQuantities,
  shippedQuantities,
  dispatchGetProcessedQuantities,
  dispatchGetShippedQuantities,
  processedShipmentsNaturesQuantities,
  processedItemsNaturesQuantities,
  dispatchGetProcessedItemsNaturesQuantities,
  dispatchGetProcessedShipmentsNaturesQuantities,
  loadingShippedQuantities,
  loadingProcessedQuantities,
  loadingProcessedShipmentsNaturesQuantities,
  loadingProcessedItemsNaturesQuantities
}) => {
  const [tabValue, setTabValue] = useState('commands');
  const initialOptions = {
    chart: {
      type: 'column'
    },
    title: {
      text: ''
    },
    yAxis: {
      title: {
        text: ''
      }
    },
    credits: {
      enabled: false
    },
    xAxis: {
      type: 'category'
    },
    plotOptions: {
      column: {
        borderRadius: 8
      },
      series: {
        pointWidth: 12
      }
    },
    series: [
      {
        name: 'Envoyés',
        color: '#4C76BB',
        data: shippedQuantities.map(shipped => ({
          name: shipped.period,
          y: shipped.itemsQuantity
        }))
      },
      {
        name: 'Retournées',
        color: '#72A517',
        data: processedQuantities.map(processed => ({
          name: processed.period,
          y: processed.returnedItemsQuantity
        }))
      }
    ]
  };
  const [hightChartOption, setHightChartOption] = useState(initialOptions);
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
    switch (newValue) {
      case 'commands':
        setHightChartOption({
          ...initialOptions,
          tooltip: {
            useHTML: true,
            // eslint-disable-next-line func-names
            // eslint-disable-next-line object-shorthand
            // eslint-disable-next-line func-names
            formatter: function() {
              const currentNature =
                processedShipmentsNaturesQuantities.find(
                  e => e.period === this.point.name
                ) || {};
              return `
                <table>
                  <tr>
                    <td>Échanges :</td>
                    <td style="text-align: right"><b>${currentNature.exchangeQuantity}</b></td>
                  </tr>
                  <tr>
                    <td>Remboursements :</td>
                    <td style="text-align: right"><b>${currentNature.returnQuantity}</b></td>
                  </tr>
                  <tr>
                    <td>Mixtes :</td>
                    <td style="text-align: right"><b>${currentNature.mixedQuantity}</b></td>
                  </tr>
                </table>
            `;
            }
          },

          series: [
            {
              name: 'Envoyés',
              color: '#4C76BB',
              data: shippedQuantities.map(shipped => ({
                name: shipped.period,
                y: shipped.commandsQuantity
              }))
            },
            {
              name: 'Retournées',
              color: '#72A517',
              data: processedQuantities.map(processed => ({
                name: processed.period,
                y: processed.vouchersQuantity
              }))
            }
          ]
        });
        return;
      case 'items':
        setHightChartOption({
          ...initialOptions,
          tooltip: {
            useHTML: true,
            // eslint-disable-next-line func-names
            // eslint-disable-next-line object-shorthand
            // eslint-disable-next-line func-names
            formatter: function() {
              const currentNature =
                processedItemsNaturesQuantities.find(
                  e => e.period === this.point.name
                ) || {};
              return `
              <table>
                <tr>
                  <td>Échanges :</td>
                  <td style="text-align: right"><b>${currentNature.exchangeQuantity}</b></td>
                </tr>
                <tr>
                  <td>Remboursements :</td>
                  <td style="text-align: right"><b>${currentNature.returnQuantity}</b></td>
                </tr>
              </table>
            `;
            }
          },
          series: [
            {
              name: 'Envoyés',
              color: '#4C76BB',
              data: shippedQuantities.map(shipped => ({
                name: shipped.period,
                y: shipped.itemsQuantity
              }))
            },
            {
              name: 'Retournées',
              color: '#72A517',
              data: processedQuantities.map(processed => ({
                name: processed.period,
                y: processed.returnedItemsQuantity
              }))
            }
          ]
        });
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    handleChange(undefined, tabValue);
  }, [processedQuantities, shippedQuantities]);

  return (
    <Paper
      style={{
        paddingTop: 48,
        paddingLeft: 80,
        paddingRight: 80,
        borderRadius: 20
      }}
    >
      <Box display="flex" justifyContent="space-between" mb={2}>
        <Box display="flex" alignItems="center">
          <Box fontSize={21} color="#001C56">
            Envoyés, Retournés
          </Box>
          <ExportCsvButton
            onClick={() => {
              if (tabValue === 'commands') {
                const columns = ['Période', 'Colis envoyés', 'Colis retournés'];
                const rows = shippedQuantities.map((shipped, i) => {
                  const processed = processedQuantities[i] || {};
                  return [
                    shipped.period,
                    shipped.commandsQuantity,
                    processed.vouchersQuantity || 0
                  ];
                });
                exportToCsv('envoyes_retournes_colis', columns, rows);
              } else {
                const columns = [
                  'Période',
                  'Produits envoyés',
                  'Produits retournés'
                ];
                const rows = shippedQuantities.map((shipped, i) => {
                  const processed = processedQuantities[i] || {};
                  return [
                    shipped.period,
                    shipped.itemsQuantity,
                    processed.returnedItemsQuantity || 0
                  ];
                });
                exportToCsv('envoyes_retournes_produits', columns, rows);
              }
            }}
            onExcelClick={() => {
              if (tabValue === 'commands') {
                const columns = ['Période', 'Colis envoyés', 'Colis retournés'];
                const rows = shippedQuantities.map((shipped, i) => {
                  const processed = processedQuantities[i] || {};
                  return [
                    shipped.period,
                    shipped.commandsQuantity,
                    processed.vouchersQuantity || 0
                  ];
                });
                exportToExcel('envoyes_retournes_colis', columns, rows);
              } else {
                const columns = [
                  'Période',
                  'Produits envoyés',
                  'Produits retournés'
                ];
                const rows = shippedQuantities.map((shipped, i) => {
                  const processed = processedQuantities[i] || {};
                  return [
                    shipped.period,
                    shipped.itemsQuantity,
                    processed.returnedItemsQuantity || 0
                  ];
                });
                exportToExcel('envoyes_retournes_produits', columns, rows);
              }
            }}
          />
        </Box>
        <PeriodicityButton
          onChange={({ dateFrom, dateTo }) => {
            const params = { dateFrom, dateTo, period: 'month' };
            dispatchGetProcessedItemsNaturesQuantities(params);
            dispatchGetProcessedShipmentsNaturesQuantities(params);
            dispatchGetProcessedQuantities(params);
            dispatchGetShippedQuantities(params);
          }}
        />
      </Box>
      <Box mb={7}>
        <Tabs
          value={tabValue}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Colis" value="commands" />
          <Tab label="Produits" value="items" />
        </Tabs>
      </Box>
      {loadingShippedQuantities ||
      loadingProcessedQuantities ||
      loadingProcessedShipmentsNaturesQuantities ||
      loadingProcessedItemsNaturesQuantities ? (
        <Box display="flex" justifyContent="center" p={20}>
          <CircularProgress size={60} />
        </Box>
      ) : (
        <HighchartsReact highcharts={Highcharts} options={hightChartOption} />
      )}
    </Paper>
  );
};

const mapStateToProps = state => ({
  processedQuantities: state.dashboard.processedQuantities,
  shippedQuantities: state.dashboard.shippedQuantities,
  loadingShippedQuantities: state.dashboard.loadingShippedQuantities,
  loadingProcessedQuantities: state.dashboard.loadingProcessedQuantities,
  processedShipmentsNaturesQuantities:
    state.dashboard.processedShipmentsNaturesQuantities,
  processedItemsNaturesQuantities:
    state.dashboard.processedItemsNaturesQuantities,
  loadingProcessedShipmentsNaturesQuantities:
    state.dashboard.loadingProcessedShipmentsNaturesQuantities,
  loadingProcessedItemsNaturesQuantities:
    state.dashboard.loadingProcessedItemsNaturesQuantities
});

const mapDispatchToProps = dispatch => ({
  dispatchGetProcessedQuantities: params =>
    dispatch(getProcessedQuantities(params)),
  dispatchGetShippedQuantities: params =>
    dispatch(getShippedQuantities(params)),
  dispatchGetProcessedItemsNaturesQuantities: params =>
    dispatch(getProcessedItemsNaturesQuantities(params)),
  dispatchGetProcessedShipmentsNaturesQuantities: params =>
    dispatch(getProcessedShipmentsNaturesQuantities(params))
});

ShippedAndReturnChart.propTypes = {
  processedQuantities: PropTypes.array, // ok
  processedShipmentsNaturesQuantities: PropTypes.array, // ok
  processedItemsNaturesQuantities: PropTypes.array,
  shippedQuantities: PropTypes.array, // ok
  dispatchGetProcessedQuantities: PropTypes.func,
  dispatchGetShippedQuantities: PropTypes.func,
  dispatchGetProcessedItemsNaturesQuantities: PropTypes.func,
  dispatchGetProcessedShipmentsNaturesQuantities: PropTypes.func,

  loadingShippedQuantities: PropTypes.bool,
  loadingProcessedQuantities: PropTypes.bool,
  loadingProcessedShipmentsNaturesQuantities: PropTypes.bool,
  loadingProcessedItemsNaturesQuantities: PropTypes.bool
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShippedAndReturnChart);
